document.addEventListener("DOMContentLoaded", function () {
	let id = ".mm-splide-products";
	let splideElem = document.querySelector(id);
	if (splideElem) {
		const slides = splideElem.querySelectorAll('.splide__slide');
		const showArrows = slides.length > 3;
		const progressBarContainer = splideElem.querySelector('.mm-splide-progress-bar-container');
		const progressBar = splideElem.querySelector('.mm-splide-progress-bar');

		if (progressBarContainer && progressBar) {
			// Afficher la barre de progression sur mobile (< 768px)
			const updateProgressBarVisibility = () => {
				progressBarContainer.style.display = window.innerWidth < 768 ? 'block' : (showArrows ? 'block' : 'none');
			};

			// Mettre à jour la visibilité au chargement et au redimensionnement
			updateProgressBarVisibility();
			window.addEventListener('resize', updateProgressBarVisibility);
		}

		const splideCards = new Splide(splideElem, {
			type: "slide",
			arrows: showArrows,
			pagination: false,
			gap: 20,
			perPage: slides.length <= 3 ? 3 : 4,
			perMove: 1,
			padding: {
				right: 0,
				left: 0,
			},
			fixedWidth: slides.length <= 3 ? "calc((100% - 40px) / 3)" : "calc((100% - 60px) / 4)",
			breakpoints: {
				1200: {
					perPage: slides.length <= 3 ? 3 : 3,
					fixedWidth: "calc((100% - 40px) / 3)",
					arrows: showArrows
				},
				1024: {
					perPage: 2,
					arrows: false,
					fixedWidth: "calc((100% - 40px) / 2)",
					padding: {
						right: 25,
						left: 0,
					},
					pagination: false,
					trimSpace: false,
				},
				500: {
					perPage: 1,
					arrows: false,
					fixedWidth: "calc(100% - 25px)",
					padding: {
						right: 25,
						left: 0,
					},
					pagination: false,
					trimSpace: false,
				},
			},
		});

		// Mise à jour de la barre de progression
		if (progressBar) {
			const updateProgressBar = () => {
				const totalSlides = splideCards.Components.Controller.getEnd() + 1;
				const currentSlide = splideCards.index + 1;
				const progress = (currentSlide / totalSlides) * 100;
				progressBar.style.width = `${progress}%`;
			};

			splideCards.on('move', updateProgressBar);
			splideCards.on('mounted', updateProgressBar);
		}

		splideCards.mount();
	}
});
